import { IValidateParamsConstans, } from "../entities/IValidateParams";
export var ValidateParamsMapper = function (data) {
    var validateParams = {
        email: ReturnIValidateParamsSubEntity(),
        mobile: ReturnIValidateParamsSubEntity(),
        clientDOB: ReturnIValidateParamsSubEntity(),
        facta: ReturnIValidateParamsSubEntity(),
        ckycNo: ReturnIValidateParamsSubEntity(),
        dpAccountNo: ReturnIValidateParamsSubEntity(),
        dpNomination: ReturnIValidateParamsSubEntity(),
        bankAccountNo: ReturnIValidateParamsSubEntity(),
        ifsc: ReturnIValidateParamsSubEntity(),
        memorandumStatus: ReturnIValidateParamsSubEntity(),
        memorandumDue: ReturnIValidateParamsSubEntity(),
        incomeRange: ReturnIValidateParamsSubEntity(),
        dormantDate: ReturnIValidateParamsSubEntity(),
        dormantDuration: ReturnIValidateParamsSubEntity(),
        lastTradeDate: ReturnIValidateParamsSubEntity(),
        lastIncomeDate: ReturnIValidateParamsSubEntity(),
        kra: ReturnIValidateParamsSubEntity(),
        aml: ReturnIValidateParamsSubEntity(),
        panNo: ReturnIValidateParamsSubEntity(),
        panStatus: ReturnIValidateParamsSubEntity(),
        tradingNomination: ReturnIValidateParamsSubEntity(),
        clientName: ReturnIValidateParamsSubEntity(),
        // photo:ReturnIValidateParamsSubEntity(),
        // signature:ReturnIValidateParamsSubEntity(),
        // complianceInitiated:ReturnIValidateParamsSubEntity()
    };
    if (data && data.length > 0) {
        data.map(function (record) {
            switch (record.fieldName) {
                case IValidateParamsConstans.RM:
                    validateParams.rm.fieldValue = record.values;
                    validateParams.rm.highReason = record.reason != "" ? true : false;
                    validateParams.rm.isPassFail = record.passFail;
                    validateParams.rm.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.Email:
                    validateParams.email.fieldValue = record.values;
                    validateParams.email.highReason = record.reason != "" ? true : false;
                    validateParams.email.isPassFail = record.passFail;
                    validateParams.email.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.Mobile:
                    validateParams.mobile.fieldValue = record.values;
                    validateParams.mobile.highReason = record.reason != "" ? true : false;
                    validateParams.mobile.isPassFail = record.passFail;
                    validateParams.mobile.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.Client_DOB:
                    validateParams.clientDOB.fieldValue = record.values;
                    validateParams.clientDOB.highReason =
                        record.reason != "" ? true : false;
                    validateParams.clientDOB.isPassFail = record.passFail;
                    validateParams.clientDOB.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.CKYC_No:
                    validateParams.ckycNo.fieldValue = record.values;
                    validateParams.ckycNo.highReason = record.reason != "" ? true : false;
                    validateParams.ckycNo.isPassFail = record.passFail;
                    validateParams.ckycNo.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.FATCA:
                    validateParams.facta.fieldValue = record.values;
                    validateParams.facta.highReason = record.reason != "" ? true : false;
                    validateParams.facta.isPassFail = record.passFail;
                    validateParams.facta.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.DP_Account_No:
                    validateParams.dpAccountNo.fieldValue = record.values;
                    validateParams.dpAccountNo.highReason =
                        record.reason != "" ? true : false;
                    validateParams.dpAccountNo.isPassFail = record.passFail;
                    validateParams.dpAccountNo.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.Bank:
                    validateParams.bankAccountNo.fieldValue = record.values;
                    validateParams.bankAccountNo.highReason =
                        record.reason != "" ? true : false;
                    validateParams.bankAccountNo.isPassFail = record.passFail;
                    validateParams.bankAccountNo.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.IFSC:
                    validateParams.ifsc.fieldValue = record.values;
                    validateParams.ifsc.highReason = record.reason != "" ? true : false;
                    validateParams.ifsc.isPassFail = record.passFail;
                    validateParams.ifsc.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.Memorandum:
                    validateParams.memorandumDue.fieldValue =
                        record.passFail === "F" ? record.values : "";
                    validateParams.memorandumDue.highReason =
                        record.reason != "" ? true : false;
                    validateParams.memorandumDue.isPassFail = record.passFail;
                    validateParams.memorandumDue.isValid = record.isvalidDays;
                    validateParams.memorandumStatus.fieldValue =
                        record.passFail === "P" ? record.values : "Pending";
                    validateParams.memorandumStatus.highReason =
                        record.reason != "" ? true : false;
                    validateParams.memorandumStatus.isPassFail = record.passFail;
                    validateParams.memorandumStatus.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.Income_Range:
                    validateParams.incomeRange.fieldValue = record.values;
                    validateParams.incomeRange.highReason =
                        record.reason != "" ? true : false;
                    validateParams.incomeRange.isPassFail = record.passFail;
                    validateParams.incomeRange.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.Dormant_Date:
                    validateParams.dormantDate.fieldValue = record.values;
                    validateParams.dormantDate.highReason =
                        record.reason != "" ? true : false;
                    validateParams.dormantDate.isPassFail = record.passFail;
                    validateParams.dormantDate.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.Dormant_Duration:
                    validateParams.dormantDuration.fieldValue = record.values;
                    validateParams.dormantDuration.highReason =
                        record.reason != "" ? true : false;
                    validateParams.dormantDuration.isPassFail = record.passFail;
                    validateParams.dormantDuration.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.Trading_Nomination:
                    validateParams.tradingNomination.fieldValue = record.values;
                    validateParams.tradingNomination.highReason =
                        record.reason != "" ? true : false;
                    validateParams.tradingNomination.isPassFail = record.passFail;
                    validateParams.tradingNomination.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.Last_Income_Date:
                    validateParams.lastIncomeDate.fieldValue = record.values;
                    validateParams.lastIncomeDate.highReason =
                        record.reason != "" ? true : false;
                    validateParams.lastIncomeDate.isPassFail = record.passFail;
                    validateParams.lastIncomeDate.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.KRA:
                    validateParams.kra.fieldValue = record.values;
                    validateParams.kra.highReason = record.reason != "" ? true : false;
                    validateParams.kra.isPassFail = record.passFail;
                    validateParams.kra.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.AML:
                    validateParams.aml.fieldValue = record.values;
                    validateParams.aml.highReason = record.reason != "" ? true : false;
                    validateParams.aml.isPassFail = record.passFail;
                    validateParams.aml.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.PANNO:
                    validateParams.panNo.fieldValue = record.values;
                    validateParams.panNo.highReason = record.reason != "" ? true : false;
                    validateParams.panNo.isPassFail = record.passFail;
                    validateParams.panNo.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.PAN_Status:
                    validateParams.panStatus.fieldValue = record.values;
                    validateParams.panStatus.highReason =
                        record.reason != "" ? true : false;
                    validateParams.panStatus.isPassFail = record.passFail;
                    validateParams.panStatus.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.DP_Nomination:
                    validateParams.dpNomination.fieldValue = record.values;
                    validateParams.dpNomination.highReason =
                        record.reason != "" ? true : false;
                    validateParams.dpNomination.isPassFail = record.passFail;
                    validateParams.dpNomination.isValid = record.isvalidDays;
                    break;
                case IValidateParamsConstans.Client_Name:
                    validateParams.clientName.fieldValue = record.values;
                    validateParams.clientName.highReason =
                        record.reason != "" ? true : false;
                    validateParams.clientName.isPassFail = record.passFail;
                    validateParams.clientName.isValid = record.isvalidDays;
                    break;
                // case IValidateParamsConstans.Photo:
                //   validateParams.photo.fieldValue = record.values;
                //   validateParams.photo.highReason = record.reason != '' ? true : false;
                //   validateParams.photo.isPassFail = record.passFail;
                //   validateParams.photo.isValid = record.isvalidDays;
                //   break;
                // case IValidateParamsConstans.Signature:
                //   validateParams.signature.fieldValue = record.values;
                //   validateParams.signature.highReason = record.reason != '' ? true : false;
                //   validateParams.signature.isPassFail = record.passFail;
                //   validateParams.signature.isValid = record.isvalidDays;
                //   break;
                // case IValidateParamsConstans.Compliance_Initiated:
                //   validateParams.complianceInitiated.fieldValue = record.values;
                //   validateParams.complianceInitiated.highReason = record.reason != '' ? true : false;
                //   validateParams.complianceInitiated.isPassFail = record.passFail;
                //   validateParams.complianceInitiated.isValid = record.isvalidDays;
                //   break;
            }
            // if(record.fieldName != 'RM'){
            //   if(record.reason != ''){
            //     validateParams.allReasons = true;
            //   }
            //   if(record.passFail == 'F')
            //   {
            //     validateParams.isEnableButton = false;
            //   }
            // }
            // if(record.isvalidDays == 'N')
            // {
            //   validateParams.isEnableButton = true;
            // }
        });
    }
    return validateParams;
};
var ReturnIValidateParamsSubEntity = function () {
    var subObj = {
        fieldValue: "",
        isPassFail: "",
        highReason: null,
        isValid: "",
    };
    return subObj;
};
